<template>
	<div>
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col lg="6" cols="7">
					<p class="text-muted">Customer List</p>
					<h2 class="text-xl d-inline-block mb-0">All Customer</h2>
				</b-col>
			</b-row>
		</base-header>

		<b-container fluid class="mt--6">
			<AllCustomerTable />
		</b-container>
	</div>
</template>
<script>
import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
import AllCustomerTable from '@/views/AllCustomers/AllCustomerTable';

export default {
	components: {
		AllCustomerTable,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			isTableLoading: true,
		}
	}
}
</script>